import { useApiTradeV1TradeCompaniesRetrieve } from 'api';
import { useTranslation } from 'i18n';
import { Link, useParams } from 'react-router-dom';
import { CenteredLoader, Page, Section } from 'ui';

import { NewCompanySiteMaterialForm } from '../../components/NewCompanySiteMaterialForm/NewCompanySiteMaterialForm';

export const NewSiteMaterial = () => {
  const { t } = useTranslation('orders');
  const { companyId } = useParams();
  const { data: tradeCompany, isLoading } = useApiTradeV1TradeCompaniesRetrieve(Number(companyId));

  if (isLoading || !tradeCompany) {
    return <CenteredLoader />;
  }

  return (
    <Page>
      <Page.BackButton component={Link} to={`/ground-control/v2/manage-company/${companyId}/site-materials`}>
        {t('siteMaterials.updatePage.actions.backToCompanySiteMaterials', {
          values: { companyName: tradeCompany.name },
        })}
      </Page.BackButton>
      <Page.Title
        title={t('siteMaterials.createPage.title', {
          values: { companyName: tradeCompany.name },
        })}
      />
      <Page.Divider />
      <Section>
        <NewCompanySiteMaterialForm companyId={tradeCompany.id} />
      </Section>
    </Page>
  );
};
